/**
 * Testimonial Rating is server-rendered (see Blocks/TestimonialRating.php) — the
 * 5 stars are emitted from the ratingPoint attribute, not baked into content.
 * Save nothing; the pre-conversion markup is kept valid by the deprecation.
 */
export default function Save() {
  return null;
}
